export default __webpack_public_path__ + "static/media/voting.793674f2.png";